import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule, Http, RequestOptions } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { AngularDraggableModule } from 'angular2-draggable';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ToastrModule } from 'ngx-toastr';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { GestureConfig, MatDialogModule, MatProgressBarModule, MatSliderModule, MatSlideToggleModule } from '@angular/material';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CookieModule } from 'ngx-cookie';
import { ContextMenuModule} from 'ngx-contextmenu';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgDragDropModule } from 'ng-drag-drop';

import { AppComponent } from './app.component';
import { PortalComponent } from './components/portal/portal.component';
import { PortalHomeComponent } from './components/portal/portal-home/portal-home.component';

import { LoginComponent } from './components/auth/login/login.component';
import { RegisterComponent } from './components/auth/register/register.component';
import { RegisterVerifyComponent } from './components/auth/register-verify/register-verify.component';
import { ResetPwComponent } from './components/auth/reset-pw/reset-pw.component';
import { RetrievePwComponent } from './components/auth/retrieve-pw/retrieve-pw.component';
import { RegisterMessageComponent } from './components/auth/register-message/register-message.component';

import { A3iNagService } from './common-services/a3i-nag.service';
import { A3iSettingService } from './common-services/a3i-setting.service';
import { AuthenticationService } from './components/auth/auth.service';
import { AdminService } from './common-services/admin.service';
import { AppinfoPreService } from './common-services/appinfo-pre.service';
import { AppinfoService } from './common-services/appinfo.service';
import { AttrIndexService } from './common-services/attr-index.service';
import { CommonRequestService } from './common-services/common-request.service';
import { CommonFunctionService } from './common-services/common-function.service';
import { CommonRequestTableService } from './common-services/common-table-request.service';
import { CommonGfoService } from './common-services/common-gfo.service';
import { CommonModalService } from './common-services/common-modal.service';
import { CommonTableService } from './common-services/common-table.service';
import { CommonUploadService } from './common-services/common-upload.service';
import { CommonUtilityService } from './common-services/common-utility';
import { UserService } from './common-services/user.service';
import { IdleService } from './common-services/idle.service';
import { LayersService } from './common-services/layers.service';
import { LbeMapService } from './common-services/lbe-map.service';
import { LbeSettingService } from './common-services/lbe-setting.service';
import { LrsService } from './common-services/lrs.service';
import { LbeUploadService } from './common-services/lbe-upload.service';
import { ProjectService } from './common-services/project.service';
import { UserManagementService } from './common-services/user-management.service';
import { SubscriptionManagementService } from './common-services/subscription-management.service';
import { SymbologysService } from './common-services/symbologys.service';
import { AuthGuardService } from './common-services/auth-guard.service';
import { ResolverAppinfoService } from './common-services/resolver-appinfo.service';
import { ResolverCustomerAppInfoService } from './common-services/resolver-customer-app-info.service';
import { ResolverAppsService } from './common-services/resolver-apps.service';
import { ResolverSubscriptionsService } from './common-services/resolver-subscriptions.service';
import { ResolverSymbologysService } from './common-services/resolver-symbologys.service';
import { ResolverUserSubsService } from './common-services/resolver-user-subs.service';
import { ResolverLbeLrsService } from './common-services/resolver-lbe-lrs.service';
import { ResolverLbeProjectsService } from './common-services/resolver-lbe-projects.service';
import { SocketService } from './common-services/socket.service';
import { RefWindowService } from './common-services/ref-window.service';

import { StepControlComponent } from './feature-components/step-control/step-control.component';
import { LoadingSpinnerComponent } from './feature-components/loading-spinner/loading-spinner.component';
import { PasswordStrengthBarComponent } from './feature-components/password-strength-bar/password-strength-bar.component';
import { CommonSuccessPageComponent } from './components/common-success-page/common-success-page.component';
import { SubscriptionManageComponent } from './components/portal/subscription-manage/subscription-manage.component';
// import { CommonAuthComponent } from './components/common-auth/common-auth.component';
import { ModalIdleComponent } from './components/modal-idle/modal-idle.component';
import { UserManageComponent } from './components/portal/user-manage/user-manage.component';
import { AppRoutingModule } from './/app-routing.module';
import { ValidateEqualDirective } from './directives/validations/validate-equal.directive';
import { RegisterApproveComponent } from './components/auth/register-approve/register-approve.component';
import { RoleManagementComponent } from './components/portal/role-management/role-management.component';
import { CommonDatagridComponent } from './components/common-datagrid/common-datagrid.component';
import { CommonTablePagingComponent } from './components/common-datagrid/common-table-paging/common-table-paging.component';
import { TableDataPipe } from './pipes/table-data.pipe';
import { PageFooterComponent } from './components/page-footer/page-footer.component';
// import { ModalSubDetailComponent } from './components/portal/subscription-manage/modal-sub-detail/modal-sub-detail.component';
import { CommonConfirmModalComponent } from './components/common-confirm-modal/common-confirm-modal.component';
import { ModalSubUpdateComponent } from './components/portal/subscription-manage/modal-sub-update/modal-sub-update.component';
import { ModalSubRenewComponent } from './components/portal/subscription-manage/modal-sub-renew/modal-sub-renew.component';
import { ModalSubSubscribeComponent } from './components/portal/subscription-manage/modal-sub-subscribe/modal-sub-subscribe.component';
import { SubLevelSliderComponent } from './components/portal/subscription-manage/sub-level-slider/sub-level-slider.component';
import { LeftMenuComponent } from './components/portal/left-menu/left-menu.component';
import { HpmsSettingComponent } from './components/portal/hpms-setting/hpms-setting.component';
import { LbeSettingComponent } from './components/portal/lbe-setting/lbe-setting.component';
import { LbeUploadComponent } from './components/portal/lbe-setting/lbe-upload/lbe-upload.component';
import { LbeUploadArnoldComponent } from './components/portal/lbe-setting/lbe-upload/lbe-upload-arnold/lbe-upload-arnold.component';
import { LbeMapComponent } from './components/portal/lbe-setting/lbe-map/lbe-map.component';
import { LbeLrsComponent } from './components/portal/lbe-setting/lbe-lrs/lbe-lrs.component';
import { LbeSymbologyComponent } from './components/portal/lbe-setting/lbe-symbology/lbe-symbology.component';
import { LbeSymbologyModalComponent } from './components/portal/lbe-setting/lbe-symbology-modal/lbe-symbology-modal.component';
import { LbePhotologComponent } from './components/portal/lbe-setting/lbe-photolog/lbe-photolog.component';
import { LbeUploadEventComponent } from './components/portal/lbe-setting/lbe-upload/lbe-upload-event/lbe-upload-event.component';
import { AgencyProfileComponent } from './components/portal/agency-profile/agency-profile.component';
import { FileDropZoneDirective } from './directives/file-drop-zone.directive';
import { ModalArnoldComponent } from './components/portal/lbe-setting/lbe-upload/modal-arnold/modal-arnold.component';
import { CommonSocketMsgComponent } from './components/common-socket-msg/common-socket-msg.component';
import { TangoColorPickerDirective } from './directives/tango-color-picker.directive';
import { CommonTangoColorpickerComponent } from './components/common-tango-colorpicker/common-tango-colorpicker.component';
import { CommonSymbolStylepickerComponent } from './components/common-symbol-stylepicker/common-symbol-stylepicker.component';
import { A3iSettingComponent } from './components/portal/a3i-setting/a3i-setting.component';
import { A3iNagComponent } from './components/portal/a3i-setting/a3i-nag/a3i-nag.component';
import { NagAliasModalComponent } from './components/portal/a3i-setting/a3i-nag/nag-alias-modal/nag-alias-modal.component';
import { NagStandardModalComponent } from './components/portal/a3i-setting/a3i-nag/nag-standard-modal/nag-standard-modal.component';
import { SuperUserComponent } from './components/portal/super-user/super-user.component';
import { SuperAdminService } from './common-services/super-admin.service';
import { GuardSubscriptionService } from './common-services/guard-subscription.service';
import { GuardSuperUserService } from './common-services/guard-super-user.service';
import { ResolverFeatureToggleService } from './common-services/resolver-feature-toggle.service';
import { FeatureToggleService } from './common-services/feature-toggle.service';
import { FeatureToggleSettingComponent } from './components/portal/super-user/feature-toggle-setting/feature-toggle-setting.component';
import { OrganizationComponent } from './components/portal/super-user/organization/organization.component';
import { LbmConfigComponent } from './components/portal/super-user/lbm-config/lbm-config.component';
import { LbmEditModalComponent } from './components/portal/super-user/lbm-config/lbm-edit-modal/lbm-edit-modal.component';
import { GisticSiteAdminComponent } from './components/portal/super-user/gistic-site-admin/gistic-site-admin.component';
import { ResolverGisticUsersService } from './common-services/resolver-gistic-users.service';
import { LbeLayerColumnsComponent } from './components/portal/lbe-setting/lbe-layer-columns/lbe-layer-columns.component';
import { MapCursorSelectComponent } from './components/portal/lbe-setting/lbe-map/map-cursor-select/map-cursor-select.component';
import { EsriUserService } from './common-services/esri-user.service';
import { AuthDirectComponent } from './components/auth-direct/auth-direct.component';
import { AuthTypeGuardService } from './common-services/auth-type-guard.service';
import { ModalUsersEsriComponent } from './components/portal/user-manage/modal-users-esri/modal-users-esri.component';
import { ModalUsersAdComponent } from './components/portal/user-manage/modal-users-ad/modal-users-ad.component';
import { FeatAuthTypeSelectComponent } from './components/portal/feat-auth-type-select/feat-auth-type-select.component';
import { UrlSerializer } from '@angular/router';
import { CustomUrlSerializer } from './CustomUrlSerializer';
import { SettingsNinjaComponent } from './components/portal/settings-ninja/settings-ninja.component';
import { NinjaMetaComponent } from './components/portal/settings-ninja/ninja-meta/ninja-meta.component';
import { NinjaLayersComponent } from './components/portal/settings-ninja/ninja-layers/ninja-layers.component';
import { SettingsNinjaService } from './common-services/settings-ninja.service';
import { ResolverNinjaInfoService } from './common-services/resolver-ninja-info.service';
import { NinjaColumnsComponent } from './components/portal/settings-ninja/ninja-layers/ninja-columns/ninja-columns.component';
import { NinjaSystemColumnMappingComponent } from './components/portal/settings-ninja/ninja-system-column-mapping/ninja-system-column-mapping.component';
import { NinjaSystemColumnsTemplateComponent } from './components/portal/settings-ninja/ninja-meta/ninja-system-columns-template/ninja-system-columns-template.component';
import { A3iApikeyComponent } from './components/portal/a3i-setting/a3i-apikey/a3i-apikey.component';
import { GisticDashboardComponent } from './components/portal/gistic-dashboard/gistic-dashboard.component';
import { LayerTableComponent } from './components/portal/gistic-dashboard/layer-table/layer-table.component';
import { MatTabsModule } from '@angular/material';
import { UserTableComponent } from './components/portal/gistic-dashboard/user-table/user-table.component';
import { IntegratorTableComponent } from './components/portal/gistic-dashboard/integrator-table/integrator-table.component';

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
	return new AuthHttp(new AuthConfig({
		noTokenScheme: true
	}), http, options);
}
export function initAuth(userService: UserService, esriUserService: EsriUserService) {
	return async () => {
		// set token from local storage
		let token = localStorage.getItem('token');
        // Check if token is in url
        // Reference: https://developers.arcgis.com/documentation/core-concepts/security-and-authentication/browser-based-user-logins/#using-the-arcgis-api-for-javascript
        const matchToken = (window.location.hash) ? window.location.hash.match(/#access_token=([^&]+)/) : false;
        const matchUsername = (window.location.hash) ? window.location.hash.match(/username=([^&]+)/) : false;
		// if we found an access token in the URL pass the token up to a global function in
		if(matchToken && matchToken[1] && matchUsername && matchUsername[1]) {
            const esriToken = matchToken[1];
			const userName = matchUsername[1];
			// update esriToken
			esriUserService.esriToken = esriToken;
			//
			try {
				const esriUserInfo = await esriUserService.getEsriUserInfo(userName, esriToken);
				//
				const res = await esriUserService.getTokenWithUserEmail(esriUserInfo.email);
				// update token
				token = res.payload.content;
			} catch (err) {
				console.log(err);
			}
		}
		// update userInfo
		userService.setUpdatedToken(token);
	}
}
export function initAppinfoPre(appinfoPreService: AppinfoPreService) {
	return (): Promise<any> => {
		return new Promise((resolve, reject) => {
			appinfoPreService.getAppInfoPre((rsp) => {
				resolve();
			}, (err) => {
				resolve(); // ???? or reject?
			});
		});
	};
}

@NgModule({
	declarations: [
		AppComponent,
		PortalComponent,
		LoginComponent,
		RegisterComponent,
		RegisterVerifyComponent,
		ResetPwComponent,
		RetrievePwComponent,
		RegisterMessageComponent,
		StepControlComponent,
		LoadingSpinnerComponent,
		PasswordStrengthBarComponent,
		CommonSuccessPageComponent,
		PortalHomeComponent,
		SubscriptionManageComponent,
		// CommonAuthComponent,
		ModalIdleComponent,
		UserManageComponent,
		ValidateEqualDirective,
		RegisterApproveComponent,
		RoleManagementComponent,
		CommonDatagridComponent,
		CommonTablePagingComponent,
		TableDataPipe,
		PageFooterComponent,
		// ModalSubDetailComponent,
		CommonConfirmModalComponent,
		ModalSubUpdateComponent,
		ModalSubRenewComponent,
		ModalSubSubscribeComponent,
		SubLevelSliderComponent,
		LeftMenuComponent,
		HpmsSettingComponent,
		LbeSettingComponent,
		LbeUploadComponent,
		LbeUploadArnoldComponent,
		LbeMapComponent,
		LbeLrsComponent,
		LbeSymbologyComponent,
		LbeSymbologyModalComponent,
		LbePhotologComponent,
		LbeUploadEventComponent,
		AgencyProfileComponent,
		FileDropZoneDirective,
		ModalArnoldComponent,
		CommonSocketMsgComponent,
		TangoColorPickerDirective,
		CommonTangoColorpickerComponent,
		CommonSymbolStylepickerComponent,
		A3iSettingComponent,
		A3iNagComponent,
		NagAliasModalComponent,
		NagStandardModalComponent,
		SuperUserComponent,
		FeatureToggleSettingComponent,
		OrganizationComponent,
		LbmConfigComponent,
		LbmEditModalComponent,
		GisticSiteAdminComponent,
		LbeLayerColumnsComponent,
		MapCursorSelectComponent,
		AuthDirectComponent,
		ModalUsersEsriComponent,
		ModalUsersAdComponent,
		FeatAuthTypeSelectComponent,
		SettingsNinjaComponent,
		NinjaMetaComponent,
		NinjaLayersComponent,
		NinjaColumnsComponent,
		NinjaSystemColumnMappingComponent,
		NinjaSystemColumnsTemplateComponent,
		A3iApikeyComponent,
		GisticDashboardComponent,
		LayerTableComponent,
		UserTableComponent,
		IntegratorTableComponent
	],
	entryComponents: [
		CommonConfirmModalComponent,
		LbeSymbologyModalComponent,
		ModalArnoldComponent,
		ModalIdleComponent,
		ModalSubUpdateComponent,
		ModalSubRenewComponent,
		ModalSubSubscribeComponent,
		NagAliasModalComponent,
		NagStandardModalComponent,
		LbmEditModalComponent,
		ModalUsersEsriComponent,
		ModalUsersAdComponent,
		NinjaSystemColumnMappingComponent,
		NinjaSystemColumnsTemplateComponent,
		NinjaColumnsComponent
	],
	imports: [
		AppRoutingModule,
		BrowserModule,
		HttpModule,
		FormsModule,
		BrowserAnimationsModule,
		NgxDatatableModule,
		MatDialogModule,
		MatProgressBarModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatAutocompleteModule,
		NgDragDropModule.forRoot(),
		// NouisliderModule,
		AngularDraggableModule,
		ToastrModule.forRoot(),
		CookieModule.forRoot(),
		ContextMenuModule.forRoot({
			useBootstrap4: true,
			autoFocus: true
		}),
		ColorPickerModule,
		MatTabsModule
	],
	providers: [
		{ provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
		/* {
			provide: APP_INITIALIZER,
			useFactory: initAuth,
			multi: true,
			deps: [UserService, EsriUserService]
		},
		{
			provide: APP_INITIALIZER,
			useFactory: initAppinfoPre,
			multi: true,
			deps: [AppinfoPreService]
		},
		{ 
			provide: UrlSerializer,
			useClass: CustomUrlSerializer
		}, */
		A3iNagService,
		A3iSettingService,
		AuthenticationService,
		AdminService,
		AppinfoPreService,
		AppinfoService,
		AttrIndexService,
		CommonRequestService,
		CommonFunctionService,
		CommonRequestTableService,
		CommonGfoService,
		CommonModalService,
		CommonTableService,
		CommonUtilityService,
		CommonUploadService,
		EsriUserService,
		FeatureToggleService,
		UserService,
		IdleService,
		LayersService,
		LrsService,
		LbeMapService,
		LbeSettingService,
		LbeUploadService,
		ProjectService,
		{
			provide: AuthHttp,
			useFactory: authHttpServiceFactory,
			deps: [Http, RequestOptions]
		},
		UserManagementService,
		SubscriptionManagementService,
		SymbologysService,
		AuthGuardService,
		AuthTypeGuardService,
		GuardSubscriptionService,
		GuardSuperUserService,
		ResolverAppinfoService,
		ResolverAppsService,
		ResolverFeatureToggleService,
		ResolverGisticUsersService,
		ResolverSubscriptionsService,
		ResolverSymbologysService,
		ResolverUserSubsService,
		ResolverLbeLrsService,
		ResolverLbeProjectsService,
		ResolverCustomerAppInfoService,
		ResolverNinjaInfoService,
		SettingsNinjaService,
		SocketService,
		SuperAdminService,
		RefWindowService
	],
	bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts